module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.detail && _vm.detail.length) ? _c('div', {
    staticClass: "product-detail-box"
  }, _vm._l((_vm.detail), function(item, index) {
    return _c('div', {
      staticClass: "product-detail"
    }, [_c('div', {
      staticClass: "detail-box"
    }, [_c('div', {
      staticClass: "title-box",
      on: {
        "click": function($event) {
          return _vm.toggleDetail(index, $event)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (!item._spreadAll) ? _c('div', {
      staticClass: "arrow",
      class: [item._spread ? 'arrow-up' : 'arrow-down']
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "content-box",
      class: {
        'spread': (item._spreadAll || item._spread)
      }
    }, _vm._l((item._content), function(itemContent) {
      return _c('div', {
        staticClass: "content"
      }, [_vm._v(_vm._s(itemContent))])
    }), 0)])])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-469dd80d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-product-detail/components/desc.vue
// module id = 1026
// module chunks = 2